import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider as MUIThemeProvider, StylesProvider } from '@material-ui/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import { create } from 'jss';
import preset from 'jss-preset-default';

import getTheme from './theme';

const jss = create(preset());

const ThemeProvider = ({ children }) => {
  const theme = getTheme();

  return (
    <StylesProvider jss={jss}>
      <MUIThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </MUIThemeProvider>
    </StylesProvider>
  );
};

ThemeProvider.propTypes = {
  children: PropTypes.node,
};

ThemeProvider.defaultProps = {
  children: null,
};

export default ThemeProvider;



// WEBPACK FOOTER //
// ./src/layouts/ThemeProvider/ThemeProvider.js